import {createSelector} from "reselect";

export const customerLoanSelector = createSelector(state => state && state.loan && state.loan.customerLoanHistory, customerLoanSelector => customerLoanSelector)